/**
 * Created by rhillion on 01/07/2017.
 */
import React, {Component} from 'react'
import {firebaseDB} from './helpers/fire';
import {Container, Grid} from 'semantic-ui-react'
import ListFilters from './ListFilters';
import CardDetails from './CardDetails'

export default class CardList extends Component {

    state = {
        cards: []
    }

    componentWillMount() {
        let cards = firebaseDB.ref('cards').orderByKey();
        cards.once('value', snapshot => {
            var records = snapshot.val();
            var cards = Object.keys(records).map(key => {
                records[key].id = key
                return records[key];
            });
            this.setState({cards: cards});
        })
    }

    renderCards() {
        return this.state.cards.map(card => {
                return <Grid.Column key={card.id}>
                    <CardDetails card={card}/>
                </Grid.Column>
            }
        );
    }

    render() {
        return (
            <Grid columns={4}>
                {this.renderCards()}
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/CardList.js